import { ReturnPolicy } from './ReturnPolicy';

export default ReturnPolicy;
